export default {
  es: {
    enlaces: {
      sala_de_prensa: "/sala-de-prensa",
      contacto: "/contacto",
      fiestahoy: "/fiesta-hoy",
      metelefiesta: "/metele-fiesta",
      historia: "/la-historia-de-fiesta",
      fiestamundo: "/fiesta-por-el-mundo",
      calidad: "/calidad",
      novedades: "/novedades",
      promociones: "/promociones",
      promocion: "/promocion",
      productos: "/productos",
      producto: "/producto",
      categoria: "/categoria",
      alergeno: "/alergenos",
      distribucion: "/distribucion",
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      aviso_legal: "/aviso-legal",
      mapa_web: "/mapa-web",
      trabaja_con_nosotros: "/trabaja-con-nosotros",
      base_legal: "/base-legal",
      sobrenosotros: "/sobre-nosotros",
      fiestamolona: "/fiesta-molona",
      faqs: "/preguntas-frecuentes",
      notaprensa: "/nota-de-prensa",
      curiosidades: "/curiosidades",
      diselopiruletas: "/diselo-con-piruletas",
      momentoganador: "/momento-ganador",
      canal_informante:
        "https://compliance.legalsending.com/canal/?C=48603129019028392",
    },
    seo: {
      callofduty: {
        title: "Fiesta | Call of Duty",
        description:
          "COMPLETA EL REGISTRO y participa en el sorteo de una PlayStation®5",
      },
      kojakpower: {
        title: "Fiesta | Kojak Power",
        description:
          "COMPLETA EL REGISTRO y participa en el sorteo de una PlayStation®5",
      },
      tortujasNinja: {
        title: "Fiesta | Fresquito Tortugas Ninja",
        description:
          "Completa el registro y gana premios de película con el nuevo Fresquito Tortugas Ninja",
      },
      patrullaCanina: {
        title: "Fiesta | Frequito Patrulla Canina",
        description:
          "Completa el registro y gana premios increíbles con el nuevo Frequito Patrulla Canina",
      },
      overwatch: {
        title: "Fiesta | Lolipop Overwatch2",
        description:
          "Comprueba tu código y gana premios increíbles con el lolipop Overwatch2",
      },
    },
    generales: {
      enviar: "Enviar",
      inicio: "Inicio",
      volver: "Volver",
      aceptar: "Aceptar",
      participar: "Participar",
      tienda: "Tienda",
      cerrar: "Cerrar",
      menu: "Menú",
    },
    bannerCuriosidades: {
      titulo: "Curiosidades",
      descubrelo: "Descúbrelo",
    },
    bannerNewsletter: {
      titulo: "Suscríbete al club más",
      claim: "¡Entérate de todo y llévate descuentos Top!",
      placeholder: "Introduce tu correo y apúntate al club más top",
      subtitulo: "¡COMPLETA EL REGISTRO y estarás dentro!",
      legal:
        "<strong>Información básica sobre Protección de datos</strong>Responsable: FIESTA COLOMBINA, S.L.U. Finalidad: Envío de información periódica de nuestras actividades, productos y/o servicios por medios electrónicos. Legitimación: Consentimiento del interesado. Destinatarios: No se cederán datos a terceros, salvo obligación legal. Derechos: Acceder, rectificar, limitar y suprimir los datos, así como presentar una reclamación ante la autoridad nacional de control, como se explica en la información adicional. Información Adicional: Puede consultar la información adicional y detallada sobre Protección de Datos en nuestra “Política de Privacidad”.",
    },
    novedades: {
      titulo: "Novedades",
      buscarcategorias: "Buscar por categorías",
      otras_noticias: "Más noticias fiesta",
      ver_mas: "Ver novedades",
    },
    sobre_nosotros: {
      titulo: "Sobre nosotros",
    },
    fiestahoy: {
      titulo: "Fiesta hoy",
      sobrefiesta: {
        titulo: "Sobre fiesta",
        entradilla:
          "Fiesta se funda en Alcalá de Henares (Madrid) en 1965 y durante más de 50 años ha sido reconocida por la gran calidad de sus productos.",
        cuerpo:
          "La innovación siempre ha sido una de nuestras metas, por eso podemos presumir de ser los que metimos corazón a una piruleta y chicle a un caramelo.",
      },
      valores: {
        titulo: "Nuestros valores",
        valores: {
          trabajoequipo: {
            titulo: "Trabajo en equipo",
            cuerpo:
              "Participamos y colaboramos con entusiasmo en cada uno de los procesos; buscamos con nuestro trabajo individual y colectivo la sinergia del equipo para lograr los mejores resultados.",
          },
          compromiso: {
            titulo: "Compromiso",
            cuerpo:
              "Estamos comprometidos con esmero a participar activamente en el desarrollo de nuestros objetivos individuales y organizacionales con honestidad y lealtad, en todo momento y en todo lugar.",
          },
          respeto: {
            titulo: "Respeto",
            cuerpo:
              "Respetamos y reconocemos las iniciativas de cada uno; damos un trato digno, franco y tolerante donde aceptamos la crítica para seguir creciendo y desempeñando un papel importante en el logro de nuestra meta.",
          },
          orientacion: {
            titulo: "Orientación al cliente",
            cuerpo:
              "Participamos y colaboramos con entusiasmo en cada uno de los procesos; buscamos con nuestro trabajo individual y colectivo la sinergia del equipo para lograr los mejores resultados.",
          },
          innovacion: {
            titulo: "Creatividad e Innovación",
            cuerpo:
              "Creemos en nuestro talento y creatividad, proporcionamos constantes desarrollos e innovamos en el diseño de nuestros productos, teniendo como objetivo primordial la satisfacción de nuestros consumidores.",
          },
        },
      },
      politicascalidad: {
        titulo: "Nuestras políticas de calidad",
        entradilla:
          "Nuestras plantas cuentan con los más altos estándares de calidad, inocuidad, seguridad alimentaria, protección del medio ambiente y seguridad física que garantizan que nuestros productos son aptos y seguros para su consumo.",
        cuerpo:
          "En Fiesta trabajamos a lo largo de toda la cadena de valor para garantizar la calidad e inocuidad de nuestros productos, capacitando al equipo humano de nuestras plantas y desarrollando acciones preventivas para minimizar las variaciones en procesos de producción, almacenamiento, y distribución.",
      },
      responsabilidadsocial: {
        titulo: "Responsabilidad social corporativa",
        entradilla: "",
        cuerpo:
          "<strong>La responsabilidad social corporativa</strong> es un pilar fundamental en <strong>la estrategia global de nuestra compañía</strong>. En Fiesta estamos comprometidos con el desarrollo sostenible, y trabajamos para promover el bienestar social y mitigar nuestro impacto ambiental, protegiendo y cuidando el medio ambiente.<br>A continuación, podéis consultar el <strong>Estado de Información No Financiera (EINF)</strong> correspondiente al ejercicio 2023. En él resaltamos las acciones más significativas que llevamos a cabo, en el marco de nuestra estrategia de sostenibilidad, en cuestiones ambientales, sociales, de derechos humanos, laborales o  de diversidad, entre otras, con el propósito de proporcionar una visión clara y precisa de nuestro <strong>compromiso con la sostenibilidad empresarial</strong> y con la <strong>innovación</strong>.",
      },
      sabermas: "Saber más",
    },
    calidad: {
      titulo: "Calidad",
      intro: "Nuestros productos son sinónimo de calidad.",
      tipscalidad: {
        caramelos: {
          cuerpo:
            "Nuestros caramelos con palo tienen hasta un +10% relleno frente a la competencia.",
        },
        palito: {
          cuerpo:
            "El palito de papel biodegradable resulta una medida de seguridad en caso de caídas accidentales.",
        },
        alergenos: {
          cuerpo:
            "Eliminamos los principales alérgenos de todos nuestros procesos productivos (excepto en línea de regaliz).",
        },
        ninos: {
          cuerpo: "Trabajamos para los públicos más exigentes:<br>LOS NIÑOS.",
        },
      },
      certificaciones: {
        titulo: "Certificaciones",
        cuerpo: [
          "El aumento de las expectativas de los consumidores, la mayor responsabilidad de los fabricantes, el incremento de exigencias legales y la globalización del abastecimiento de productos, han hecho necesario desarrollar estándares para el aseguramiento de la calidad.",
          "FIESTA se somete anualmente a completas auditorías de certificación cuyo alcance recoge todos los productos fabricados en nuestras instalaciones de Alcalá de Henares (caramelo duro con y sin relleno, caramelo duro relleno de chicle, caramelo duro con polvo ácido, caramelo masticable, caramelo duro sin azúcar, regaliz con y sin relleno) para garantizar la seguridad alimentaria.",
          // "FIESTA cuenta con las más altas puntuaciones en las siguientes certificaciones:",
        ],
        certificacion: {
          titulo: "BRC (British Retailer Consortium): Grado A (Safety)",
          cuerpo: [
            "El estándar BRC Food es una norma que recoge requisitos de Calidad y la Seguridad Alimentaria.  Es aplicable a fabricantes de alimentos (hay otras para distribuidores, fabricantes de envases…). Fue creada por la Asociación de Minoristas Británicos o British Retail Consortium (BRC) pero hoy en día tiene reconocimiento internacional.",
            "Tiene un alto nivel de exigencia con requisitos que van más allá del cumplimiento legal.",
          ],
        },
      },
      alergenos: {
        titulo: "Alérgenos",
        cuerpo:
          "Desde FIESTA se siguen unas políticas muy claras enfocadas a la eliminación de todos los alérgenos posibles y a la minimización de aquellos que por razones tecnológicas no ha sido posible aún eliminar.",
      },
      vermas: "Ver<br>más",
    },
    trabaja: {
      titulo: "Trabaja con nosotros",
      introtext:
        "¿Quieres trabajar con nosotros?<br>Completa este formulario y únete a la fiesta:",
      dropzone: "Arrastra tu archivo o haz click para adjuntarlo",
      unete: "Únete al<br>equipo",
    },
    contacto: {
      titulo: "Contacto",
      intro:
        "¿Quieres hablar con nosotros? Déjanos tu mensaje en este formulario.",
      empresa: "Fiesta Colombina, S.L.U.",
      direccion_1: "Avda. de Madrid, 46",
      direccion_2: "28802 Alcalá de Henares, Madrid, España",
    },
    saladeprensa: {
      titulo: "Sala de prensa",
      intro:
        "Si necesitas contactar con nuestro departamento de comunicación… ¡déjanos un mensaje!",
      notasprensa: "Notas de prensa",
      kit: "Kit de prensa",
      descargakit: "Descargar<br>el kit",
    },
    calidad_reclamaciones: {
      titulo: "¿Problemas con algún producto?",
      query: "calidad_reclamaciones",
    },
    bannerRRSS: {
      claim: "Síguenos y llévate premios molones",
      siguenos: "Síguenos",
    },
    promociones: {
      titulo: "Promociones",
      introtext: "¡Participa en las promociones más molonas!",
      ver_mas: "Ver promociones",
      destacada: "Promo Destacada",
    },
    productos: {
      titulo: "Productos",
      otros_productos: {
        titulo: "Productos",
      },
    },
    diselopiruletas: {
      titulo: "Díselo con piruletas",
    },
    producto: {
      sabor: "sabor",
      comprar: "Comprar",
      mas_info: "Más info",
      ingredientes: "Ingredientes",
      nutricional: "Información nutricional",
      masinformacion: "Más información",
      producto: "Información producto",
      alergenos: "Alérgenos",
      alergenos_libre: "Producto libre de alérgenos",
      presencia: "Presencia en fábrica",
      presencia_libre: "Producto libre de alérgenos en fábrica",
      ficha_alergenos: "Ficha de alérgenos",
      y: "y",
      valores: {
        energetico: "Valor energético",
        grasas: "Grasas",
        grasas_saturadas: "de las cuales saturadas",
        hidratos: "Hidratos de carbono",
        hidratos_azucares: "de los cuales azúcares",
        proteinas: "Proteínas",
        sal: "Sal",
      },
      allergens: {
        celery: "Apio",
        crustaceans: "crustáceos",
        dairy: "lácteos",
        eggs: "huevos",
        fish: "pescado",
        gluten: "gluten",
        lupins: "altramuces",
        mollusk: "molusco",
        mustard: "mostaza",
        nuts: "Frutos de cáscara",
        peanut: "cacahuetes",
        sesame: "sésamo",
        soy: "soja",
        sulfur: "azufre",
        vegan: "Apto para veganos",
      },
    },
    sharelinks: {
      titulo: "Compartir",
      twitter: "Compartir en twitter",
      facebook: "Compartir en facebook",
    },
    baselegal: {
      titulo: "Bases legales promoción",
    },
    alergenos: {
      titulo: "Alérgenos",
      intro:
        "Si necesitas consultar los alérgenos de nuestros productos los encontrarás en la siguiente tabla.",
      noapto: "No apto. contiene el alérgeno",
      apto: "Apto. No contiene el alérgeno.",
      presencia: "Puede contener el alérgeno",
      filtrar: "Filtrar por alérgeno",
      texto_aviso: {
        titulo: "Importante",
        cuerpo: [
          "En nuestras instalaciones hay presencia de GLUTEN y SULFITOS.",
          "Los huevos, los cacahuetes, la soja, la leche y los frutos de cáscara no están presentes. Los productos que los contienen están fabricados en instalaciones con ubicaciones geográficas distintas de Fiesta Colombina, S.L.U. y llegan a nuestros almacenes cerrados y listos para su distribución. Por tanto, no hay riesgo de contaminación cruzada.",
          "Para otras consultas relacionadas con alérgenos por favor contacte con <a href='mailto:calidad@fiesta.es'>calidad@fiesta.es</a>",
        ],
      },
    },
    metelefiesta: {
      nombre: "Métele fiesta",
      titulo: "Si quieres un momento",
      momentos: "Los momentos más",
      productostop: "Los productos más",
      vidatop: "La vida más",
      vidatopclaim: "Si quieres hacer top cada momento, no te lo pienses.",
      vidatopel: [
        "Hacer más divertidos tus mejores momentos",
        "Reinventar por unos instantes la rutina",
        "Compartir experiencias únicas con quien tú quieras",
        "Convertir cada pequeña cosa en algo único e irrepetible",
      ],
      videos: ["BKQgIksbP3Y", "_NeyfIk4PZ8", "EYqMXHciQFU", "q_pJWFnfEMs"],
    },
    fiestamolona: {
      titulo: "Fiesta molona",
    },
    distribucion: {
      titulo: "Distribución",
      puntos: "Puntos de<br>venta",
      intro:
        "¿Quieres vender fiesta en tu establecimiento?¡Escríbenos y te informaremos!",
      catalogo: "Descargar<br>Catálogo",
      encuentranos: "¡Encuéntranos!",
      seleccionaprovincia: "Selecciona provincia",
      contactocomercial: "Contacto comercial",
      nodistribuidores: "Sin distribuidores en esta zona",
      masinformacion:
        "¿Necesitas más información? <a href='mailto:comercial@fiesta.es'>Contáctanos",
    },
    fiestamundo: {
      titulo: "Fiesta<br>por el mundo",
      titulosmall: "Fiesta por el mundo",
      intro:
        "La Calidad, originalidad y experiencia nos convierte en un marca consolidada internacionalmente.",
      tips: [
        "Marcas líderes alrededor del mundo: Fiesta, Kojak, BonBonBum, Colombina, amazon",
        "Somos una compañía centrada en clientes y consumidores",
        "Alianzas a largo plazo con nuestros colaboradores internacionales",
        "Orientados en la superación de las expectativas de negocio",
        "Nuestra trayectoria es el resultado de Calidad + Innovación + Experiencia",
        "Pertenecemos a Colombina, una multinacional líder en alimentación con 100 años de historia",
      ],
      mision: {
        titulo: "Misión",
        cuerpo:
          "Incrementar nuestra presencia a nivel internacional a través de los negocios de confitería, salsas y galletas generando valor a todos los grupos de interés.",
      },
      vision: {
        titulo: "Visión",
        cuerpo:
          "Ofrecer un servicio de calidad desde la fabricación a la comercialización de nuestros productos adaptándonos a las necesidades del cliente a través de nuestro amplio portafolio de marcas y productos.",
      },
    },
    historia: {
      titulo: "La Historia de fiesta",
      boton: "Nuestra<br>Historia",
      slide1: {
        titulo: "Nuestros orígenes",
        cuerpo:
          "Nacimos en los años 40 en el corazón de Puerto Rico de la mano del Sr. Mayoral, quien desde el primer momento se interesó por los cultivos de caña de azúcar y comenzó a extraerla para crear el primer caramelo Fiesta.",
        mayoral: "SR. MAYORAL",
      },
      slide2: {
        titulo: "Una fábrica muy dulce",
        cuerpo:
          "Establecimos nuestra primera fábrica en Venezuela, para posteriormente, en 1965, llegar a la ciudad que nos ha visto crecer: Alcalá de Henares, en Madrid, donde continuamos fabricando las mejores golosinas y caramelos Fiesta.",
        boton: "¡Descubre<br>nuestro viaje!",
      },
      slide3: {
        titulo: "Caramelos con corazón",
        cuerpo:
          "En los años 60, popularizamos el consumo de caramelos planos con palo y le dimos nombre a nuestra PIRULETA gracias a un juego de palabras entre pirulí, un dulce típico de Cuba, y paleta, como se llamaban a estos caramelos en la época.",
        cuerporae:
          "Años más tarde se cambió la forma de la piruleta de redonda a corazón. Toda una contribución a la Real Academia de la Lengua Española y un símbolo universal.",
        boton: "Leer la RAE",
        piruli: "Pirulí + paleta",
      },
      slide4: {
        titulosecreto: "¿Quieres conocer nuestro secreto mejor guardado?",
        descubrir: "Descubrir",
        sentimos: "¡Lo sentimos!",
        sentimoscuerpo: "¿Pensabas de verdad que te lo íbamos a contar?",
        sentimosclaim: "¡Jamás lo contaremos!",
        chiclecaramelo: "¿Chicle a un caramelo?",
        chiclecuerpo:
          "El lanzamiento del caramelo con palo relleno de chicle KOJAK, inspirado en una popular serie de la época, causó furor en la España de los años 70.",
        chiclecuerpo2:
          "Fuimos los primeros en meterle chicle a un caramelo gracias a un innovador proceso que aun hoy sigue siendo uno de los secretos mejores guardados de la compañía. Hasta salimos en la tele!",
        tv: [
          "AVENTURA DEL TREN",
          "Dime cual es el secreto del sabor extraordinario de Kojak o morirás aplastado por el tren de las 4.",
          "¡Je,Je!, el sabor es fenomenal.",
          "Y los hay con chicle dentro.",
          "¡PLASH!",
          "Kojak, el bueno de Fiesta. Un secreto entre tu y yo.",
          "Y no se lo digas al malo.",
          "AVENTURA DEL PRECIPICIO",
          "Dime cual es el secreto del sabor extraordinario de Kojak o morirás  despeñado.",
          "¡Je, je!, el sabor es fenomenal.",
          "Y los hay con chicle dentro.",
          "¡PLASH!",
          "Kojak, el bueno de Fiesta. Un secreto entre tu y yo.",
          "Y no se lo digas al malo.",
        ],
      },
      slide5: {
        titulo: "El más travieso y divertido",
        cuerpo:
          "A mediados de los 80, se nos ocurrió la fantástica idea de meter en un mismo sobre, polvitos pica-pica y un caramelo con palo con la forma de un dedo de Fresquito, el icónico niño que ha acompañado tantos momentos dulces de pequeños y mayores.",
      },
      slide6: {
        tituloinvasion: "La invasión de las gomas",
        cuerpoinvasion:
          "La imaginación y creatividad de nuestro equipo se volcó en crear deliciosas gomelitas con forma de frutas, animales, personajes famosos de dibujos animados de la época.",
      },
      slide7: {
        titulo: "Dulce Innovación",
        cuerpo:
          "Una vez más, fuimos pioneros en la categoría, con la instalación de nuevas líneas de regaliz, creando una amplia gama de geles dulces con la calidad y tecnología más avanzada hasta convertir marcas como Maromas y Megatorcidas en superventas.",
        cuerpo2: "¡Ya hemos dado la vuelta al mundo con nuestro regaliz!",
      },
      slide8: {
        titulo: "¡Batiendo Récords!",
        cuerpo:
          "Conseguimos entrar en Libro Guinness de los récords con la mayor concentración de gente chupando caramelos con palo. Casi 13.000 personas disfrutaron a la vez de nuestro KOJAK el 7 de septiembre de 2008 en Valladolid.",
        cuerpo2: "¡Este récord estaba chupado!",
      },
      slide9: {
        titulo: "Diseló con piruletas",
        cuerpo:
          "Cumplir medio siglo es mucho decir, pero cuando hablamos de las piruletas FIESTA no parece algo extraño. Estos deliciosos caramelos con palo en forma de corazón nos llevan acompañando tantos cumpleaños, fiestas infantiles y momentos especiales de grandes y pequeños que sólo podemos desearles: ¡Feliz cumpleaños y que cumplan muchos más!.",
        felizcumple: " <strong>Feliz</strong> cumpleaños",
      },
      irhome: "Ir a la<br>Home",
    },
    faqs: {
      titulo: "Preguntas frecuentes",
      introbanner: "Resuelve tus dudas Fiesta",
      categorias: {
        "0": "Sobre Fiesta",
        "1": "Productos",
        "2": "Contacta Fiesta",
        "3": "Compra Fiesta",
      },
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      primerapellido: "Primer Apellido",
      segundoapellidos: "Segundo Apellido",
      email: "Email",
      ciudad: "Ciudad",
      dni: "DNI",
      medio: "Medio de comunicación",
      mensaje: "Mensaje",
      telefono: "Teléfono",
      poblacion: "Población",
      fechanacimiento: "Fecha de nacimiento",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      de_fiesta: "de FIESTA",
      comunicaciones:
        "Deseo recibir comunicaciones comerciales por parte de FIESTA.",
      cp: "Código postal",
      lote: "Número de lote",
      direccion_only: "Dirección",
      direccion: "Dirección recogida/entrega",
      finalizar: "Finalizar registro",
      hombre: "Hombre",
      mujer: "Mujer",
      motivo: "Motivo",
      enviado: "Enviado",
      ticket: "Adjunta foto del envoltorio",
      participar: "Participar",
      departamentos: {
        "": "Departamento",
        Fábrica: "Fábrica",
        Almacén: "Almacén",
        Administración: "Administración",
        "Recursos Humanos": "Recursos Humanos",
        Comercial: "Comercial",
        Marketing: "Marketing",
      },
      enviar: "Enviar",
      departamentoscontacto: {
        "": "Selecciona departamento",
        "0": "Información",
        "1": "Calidad/Reclamaciones",
        "2": "Empleo",
        "3": "Comercial",
        "4": "Marketing",
      },
      motivos: {
        "nueva apertura": "Nueva apertura",
        información: "Información",
        reclamación: "Reclamación",
      },
      zonas: {
        "": "Zona",
        norte: "Norte",
        sur: "Sur",
      },
      motivoscontacto: {
        "": "Selecciona Motivo",
        Incidencia: "Incidencia",
        Información: "Información",
        Reclamación: "Reclamación",
        Sugerencias: "Sugerencias",
      },
      fotoproducto: "Foto del producto",
    },
    politica: {
      titulo: "Política de privacidad",
    },
    cookies: {
      titulo: "Política de cookies",
    },
    aviso_legal: {
      titulo: "Aviso legal",
    },
    mapa_web: {
      titulo: "Mapa web",
      sobrefiesta: "Sobre fiesta",
      lomastop: "Lo más top",
      contacta: "Contacta",
    },
    canal_informante: {
      titulo: "Canal del informante",
    },
    years: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    distribuidores_list: [
      {
        Nombre: "Francisco Javier de la Peña",
        Correo: "fdelapena@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["malaga", "cadiz"],
      },
      {
        Nombre: "Néstor Blázquez Muñoz",
        Correo: "nblazquezm@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["sevilla", "huelva"],
      },
      {
        Nombre: "Daniel Dalmases",
        Correo: "ddalmases@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["tarragona", "barcelona", "girona", "andorra"],
      },
      {
        Nombre: "José Delgado",
        Correo: "jdelgado@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: [
          "lerida",
          "huesca",
          "zaragoza",
          "aragon",
          "navarra",
          "teruel",
          "la-rioja",
        ],
      },
      {
        Nombre: "Francisco Javier Martínez Touriño",
        Correo: "fmartinezt@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["la-coruna", "lugo", "pontevedra", "ourense"],
      },
      {
        Nombre: "Victor Lendínez",
        Correo: "vlendinez@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["ciudad-real", "segovia", "avila", "toledo"],
      },
      {
        Nombre: "Pedro José Diaz Hornos",
        Correo: "phornos@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["albacete", "cuenca", "guadalajara"],
      },
      {
        Nombre: "José Luis Carralero",
        Correo: "jcarralero@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["madrid"],
      },
      {
        Nombre: "Aurelio Castro Cobos",
        Correo: "acastroc@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["badajoz", "caceres", "cordoba"],
      },
      {
        Nombre: "Andrés Almeida García",
        Correo: "aalmeida@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["asturias", "cantabria", "bizkaia"],
      },
      {
        Nombre: "Roberto Carlos Guerra Ortiz",
        Correo: "rguerra@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["gran-canaria", "tenerife"],
      },
      {
        Nombre: "Marcos Díaz Servera",
        Correo: "mdiazs@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["mallorca", "menorca", "ibiza"],
      },
      {
        Nombre: "Salvador Enrique García López",
        Correo: "segarcia@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["castellon", "valencia", "alicante", "murcia"],
      },
      {
        Nombre: "Sergio Alcántara Castro",
        Correo: "salcantara@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["almeria", "jaen", "granada"],
      },
      {
        Nombre: "Miguel A. del Álamo Carbonero",
        Correo: "madelalamo@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: [
          "palencia",
          "valladolid",
          "zamora",
          "leon",
          "burgos",
          "soria",
          "salamanca",
        ],
      },
      {
        Nombre: "Fernando Azpiasu",
        Correo: "fazpiasu@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "918881550",
        provincias: ["gipuzkoa", "alava"],
      },
    ],
    provincias: {
      alava: "Álava",
      albacete: "Albacete",
      alicante: "Alicante",
      almeria: "Almería",
      asturias: "Asturias",
      avila: "Ávila",
      badajoz: "Badajoz",
      barcelona: "Barcelona",
      burgos: "Burgos",
      caceres: "Cáceres",
      cadiz: "Cádiz",
      cantabria: "Cantabria",
      castellon: "Castellón",
      "ciudad-real": "Ciudad Real",
      cordoba: "Córdoba",
      cuenca: "Cuenca",
      girona: "Girona",
      granada: "Granada",
      guadalajara: "Guadalajara",
      guipuzcoa: "Guipúzcoa",
      gipuzkoa: "Guipúzcoa",
      huelva: "Huelva",
      huesca: "Huesca",
      ibiza: "Ibiza",
      "Islas Baleares": "Islas Baleares",
      jaen: "Jaén",
      leon: "León",
      lugo: "Lugo",
      lerida: "Lérida",
      "la-coruna": "La Coruña",
      "la-rioja": "La Rioja",
      "gran-canaria": "Las Palmas de Gran Canaria",
      mallorca: "Mallorca",
      menorca: "Menorca",
      madrid: "Madrid",
      malaga: "Málaga",
      murcia: "Murcia",
      navarra: "Navarra",
      ourense: "Orense",
      palencia: "Palencia",
      pontevedra: "Pontevedra",
      salamanca: "Salamanca",
      segovia: "Segovia",
      sevilla: "Sevilla",
      soria: "Soria",
      tenerife: "Santa Cruz de Tenerife",
      tarragona: "Tarragona",
      teruel: "Teruel",
      toledo: "Toledo",
      valencia: "Valencia",
      valladolid: "Valladolid",
      bizkaia: "Vizcaya",
      zamora: "Zamora",
      zaragoza: "Zaragoza",
    },
    errors: {
      "2": {
        titulo: "Lo sentimos",
        cuerpo: "Faltan datos obligatorios",
      },
      "3": {
        titulo: "Lo sentimos",
        cuerpo: "El pincode ya ha sido utilizado",
      },
      "4": {
        titulo: "Lo sentimos",
        cuerpo: "Este pincode no es válido o no pertenece a esta promoción",
      },
      "6": {
        titulo: "Lo sentimos",
        cuerpo: "La promo ha finalizado",
      },
      "7": {
        titulo: "Lo sentimos",
        cuerpo: "Has alcanzado el limite de participación por hoy",
      },
      "5": {
        titulo: "Lo sentimos",
        cuerpo: "El usuario no es valido",
      },
      "8": {
        titulo: "Lo sentimos",
        cuerpo:
          "¡Participa y comparte de nuevo mañana para ganar otra tirada extra!",
      },
      ok: {
        titulo: "Enhorabuena",
        cuerpo: "Ya tienes disponible tu participación extra",
      },
    },
  },
  en: {
    enlaces: {
      sala_de_prensa: "/press-room",
      contacto: "/contact",
      fiestahoy: "/fiesta-today",
      metelefiesta: "/metele-fiesta",
      historia: "/the-history-of-fiesta",
      fiestamundo: "/fiesta-around-the-globe",
      calidad: "/quality",
      novedades: "/news",
      promociones: "/promotions",
      promocion: "/promotion",
      productos: "/products",
      producto: "/product",
      categoria: "/category",
      alergeno: "/allergens",
      distribucion: "/distribution",
      politica_privacidad: "/privacy-policy",
      politica_cookies: "/cookies-policy",
      aviso_legal: "/legal-notice",
      mapa_web: "/site-map",
      trabaja_con_nosotros: "/work-with-us",
      base_legal: "/legal-basis",
      sobrenosotros: "/about-us",
      fiestamolona: "/cool-fiesta",
      faqs: "/FAQs",
      notaprensa: "/press-release",
      curiosidades: "/trivia",
      diselopiruletas: "/say-it-with-lollipops",
      momentoganador: "/competition-timer",
      canal_informante:
        "https://compliance.legalsending.com/canal/?C=48603129019028392",
    },
    seo: {
      callofduty: {
        title: "Fiesta | Call of Duty",
        description:
          "COMPLETE THE REGISTRATION FORM and enter the draw to win a PlayStation®5",
      },
    },
    generales: {
      enviar: "Submit",
      inicio: "Home",
      volver: "Back",
      aceptar: "OK",
      participar: "Participates",
      tienda: "Store",
      cerrar: "Close",
      menu: "Menu",
    },
    bannerCuriosidades: {
      titulo: "Trivia",
      descubrelo: "Find out more",
    },
    bannerNewsletter: {
      titulo: "Sign up to our Bonus Club",
      claim: "Stay in the know and take advantage of the coolest discounts!",
      placeholder:
        "Enter your email address and sign up to the coolest Bonus Club",
      subtitulo: "COMPLETE YOUR REGISTRATION and you’re in!",
      legal:
        "<strong>Basic information about Data Protection</strong>Data controller: FIESTA COLOMBINA, S.L.U.Purpose: Sending periodic information about our activities, products and/or services electronically.Legitimacy: Consent of the data subject.Recipients: Data will not be shared with third parties, except for compliance with a legal obligation. Rights: To access, rectify, limit and erase the personal data, as well as presenting a claim before a supervisory authority, as is explained in the additional information. Additional information: You may consult the additional, detailed information about Data Protection in our Privacy Policy..",
    },
    novedades: {
      titulo: "News",
      buscarcategorias: "Search by category",
      otras_noticias: "More Fiesta news",
      ver_mas: "See what’s news",
    },
    sobre_nosotros: {
      titulo: "About us",
    },
    fiestahoy: {
      titulo: "Fiesta today",
      sobrefiesta: {
        titulo: "About Fiesta",
        entradilla:
          "Fiesta was founded in Alcalá de Henares (Madrid) in 1965 and after more than 50 years it continues to be recognised for its great quality products.",
        cuerpo:
          "Innovation has always been one of our aims. For this reason, we can boast about being a company that puts its heart into a lollipop and bubble gum in its sweets.",
      },
      valores: {
        titulo: "Our values",
        valores: {
          trabajoequipo: {
            titulo: "Teamwork",
            cuerpo:
              "We participate and collaborate wholeheartedly in every process, both individually and by working together. At Fiesta, we always strive for synergy with the team itself in order to achieve the best results.",
          },
          compromiso: {
            titulo: "Commitments",
            cuerpo:
              "At Fiesta, we undertake to actively participate in the development of our individual and organisational objectives, with honesty and loyalty remaining our key priorities, at any time and anywhere.",
          },
          respeto: {
            titulo: "Respect",
            cuerpo:
              "We respect and recognise every individual’s efforts; we treat people in a dignified, straightforward and tolerant way, where we accept any criticisms in order to keep on growing and thereby playing an important role in achieving our goals.",
          },
          orientacion: {
            titulo: "Customer-oriented",
            cuerpo:
              "We participate and collaborate wholeheartedly in every process; in our individual and teamwork we strive for synergy with the team itself in order to achieve the best results.",
          },
          innovacion: {
            titulo: "Creativity and Innovation",
            cuerpo:
              "We believe in our talent and creativity. We continually develop and innovate in the design of our products, with our primary aim being the satisfaction of our consumers.",
          },
        },
      },
      politicascalidad: {
        titulo: "Our quality policies",
        entradilla:
          "Our plants offer the highest standards in quality, safety, food safety, environmental protection and physical safety, which means that we can ensure that all of our products are fit for purpose and safe for consumption.",
        cuerpo:
          "We at Fiesta work closely with the whole value chain to guarantee the quality and safety of our products, training our workforce at our plants and undertaking preventative action to minimize any variations in production processes, storage and distribution.",
      },
      responsabilidadsocial: {
        titulo: "Corporate Social Responsibility",
        entradilla:
          "At Fiesta, we pursue a global strategy in which environmental protection constitutes one of the key pillars, as we want to contribute to the planet’s welfare at all times.",
        cuerpo: "",
      },
      sabermas: "Find out more",
    },
    calidad: {
      titulo: "Quality",
      intro: "Our products are synonymous with high quality.",
      tipscalidad: {
        caramelos: {
          cuerpo:
            "Our lollipops offer up to 10% more filling compared to other brands on the market.",
        },
        palito: {
          cuerpo:
            "Our biodegradable paper lolly sticks afford extra protection in case of accidental falls, thereby prioritising the safety of our consumers at all times.",
        },
        alergenos: {
          cuerpo:
            "We have eliminated the main allergens in all of our production processes (apart from in our liquorice range).",
        },
        ninos: {
          cuerpo: "We work for the most demanding consumers:<br>CHILDREN.",
        },
      },
      certificaciones: {
        titulo: "Certifications",
        cuerpo: [
          "The growing expectations of consumers, the major responsibility of manufacturers, increased legal requirements and the globalisation of product supply have all made it necessary for standards to be developed that guarantee high quality.",
          "FIESTA undergoes full annual audits for all of its confectionery production and packaging processes (hard sweets, chewy sweets, jelly sweets, etc.) in order to therefore guarantee food safety.<br>FIESTA holds the highest scores in the following certifications:",
        ],
        certificacion: {
          titulo: "BRC (British Retail Consortium): Grade A (Safety)",
          cuerpo: [
            "The BRC Food Standard is a norm which reflects Quality and Food Safety requirements. It applies to food manufacturers (there are others for distributors, packaging manufacturers, etc.). It was created by the British Retail Consortium (BRC) but is now recognised internationally.",
            "It sets high standards with tough requirements that go beyond legal compliance.",
          ],
        },
      },
      alergenos: {
        titulo: "Allergens",
        cuerpo:
          "We at FIESTA pursue very clear policies which focus on the elimination of all possible allergens and which minimise those that cannot be eliminated for technological reasons.",
      },
      vermas: "See<br>more",
    },
    trabaja: {
      titulo: "Work with us",
      introtext:
        "Do you want to work with us?<br>Complete this form and join our fiesta:",
      dropzone: "Drag your file here or click to attach it",
      unete: "Join the<br>team",
    },
    contacto: {
      titulo: "Contact",
      intro: "Do you want to chat to us? Send us your message using this form.",
      empresa: "Fiesta Colombina, S.L.U.",
      direccion_1: "Avda. de Madrid, 46",
      direccion_2: "28802 Alcalá de Henares, Madrid, España",
    },
    saladeprensa: {
      titulo: "Press room",
      intro:
        "If you need to contact our communications department, drop us a message!",
      notasprensa: "Press releases",
      kit: "Press kit",
      descargakit: "Download<br>the kit",
    },
    calidad_reclamaciones: {
      titulo: "Problems with any product?",
      query: "quality_complaints",
    },
    bannerRRSS: {
      claim: "Follow us and win COOL prizes!",
      siguenos: "Follow us",
    },
    promociones: {
      titulo: "Promotions",
      introtext: "Get involved with the COOLEST promotions!",
      ver_mas: "See promotions",
      destacada: "Featured Promo",
    },
    productos: {
      titulo: "Products",
      otros_productos: {
        titulo: "Products",
      },
    },
    diselopiruletas: {
      titulo: "Say it with lollipops",
    },
    producto: {
      sabor: "flavour",
      comprar: "Buy",
      mas_info: "More info",
      ingredientes: "Ingredients",
      nutricional: "Nutritional information",
      masinformacion: "More información",
      producto: "Product information",
      alergenos: "Allergens",
      alergenos_libre: "Allergen-free product",
      presencia: "Presence in factories",
      presencia_libre: "Allergen-free product in the factory",
      ficha_alergenos: "Allergens sheet",
      y: "and",
      valores: {
        energetico: "Energy value",
        grasas: "Fat",
        grasas_saturadas: "of which saturates",
        hidratos: "Carbohydrate",
        hidratos_azucares: "of which sugars",
        proteinas: "Protein",
        sal: "Sodium",
      },
      allergens: {
        celery: "Celery",
        crustaceans: "crustaceans",
        dairy: "dairy",
        eggs: "eggs",
        fish: "fish",
        gluten: "gluten",
        lupins: "lupin",
        mollusk: "molluscs",
        mustard: "mustard",
        nuts: "Tree nuts",
        peanut: "peanuts",
        sesame: "sesame seeds",
        soy: "soya",
        sulfur: "sulphur dioxide",
        vegan: "Suitable for vegans",
      },
    },
    sharelinks: {
      titulo: "Share",
      twitter: "Share on Twitter",
      facebook: "Share on Facebook",
    },
    baselegal: {
      titulo: "Legal terms and conditions of offer",
    },
    alergenos: {
      titulo: "Allergens",
      intro:
        "If you need to check the allergens in our products, you will find them in the following table.",
      noapto: "Not suitable. Contains allergen",
      apto: "Suitable. Does not contain allergen.",
      presencia: "Present in the factory",
      filtrar: "Filter by allergen",
      texto_aviso: {
        titulo: "Important",
        cuerpo: [
          "At our facilities, wheat flour is only present in our liquorice line, separate from our other lines.",
          "Eggs, peanuts, soya, milk and tree nuts are not present. The products that contain them are manufactured at facilities in geographical locations that differ to Fiesta Colombina, S.L.U. and they arrive at our warehouses packaged and ready for their distribution. As a result, there is no risk of cross-contamination.",
          "For other allergen-related queries please contact <a href='mailto:calidad@fiesta.es'>calidad@fiesta.es</a>",
        ],
      },
    },
    metelefiesta: {
      nombre: "Métele fiesta",
      titulo: "If you want the BEST moment ever",
      momentos: "Experience the BEST moments",
      productostop: "Taste the BEST products",
      vidatop: "Live your BEST life",
      vidatopclaim: "If you want the best, don’t miss out!",
      vidatopel: [
        "Make your best moments more fun,",
        "Reinvent your routine for a moment,",
        "Share unique experiences with who you want,",
        "Turn every little thing into something unique and inimitable",
      ],
      videos: ["BKQgIksbP3Y", "_NeyfIk4PZ8", "EYqMXHciQFU", "q_pJWFnfEMs"],
    },
    fiestamolona: {
      titulo: "Cool Fiesta",
    },
    distribucion: {
      titulo: "Distribution",
      puntos: "Retail<br>outlets",
      intro:
        "Do you want your business to act as a retail outlet for the real Fiesta? Write to us and we’ll tell you what you need to know!",
      catalogo: "Download<br>Catalogue",
      encuentranos: "Find us!",
      seleccionaprovincia: "Select province",
      contactocomercial: "Commercial contact",
      nodistribuidores: "No distributors within this area",
      masinformacion:
        "Do you need more information? <a href=mailto:comercial@fiesta.es>Contact us",
    },
    fiestamundo: {
      titulo: "Fiesta<br>worldwide",
      titulosmall: "Fiesta worldwide",
      intro:
        "Quality, originality and experience have made us a well-established international brand.",
      tips: [
        "Leading brands around the world: Fiesta, Kojak, BonBonBum, Colombina, Amazon,",
        "We are a customer- and consumer-focused company,",
        "We foster long-term partnerships with our international partners,",
        "We aim to exceed business expectations,",
        "Our trajectory is the result of Quality + Innovation + Experience,",
        "We belong to Colombina, a multinational leader in the food industry with over 100 years of history",
      ],
      mision: {
        titulo: "Mission",
        cuerpo:
          "To increase our international presence across the businesses of confectionery, sauces and biscuits, while generating value to all stakeholders.",
      },
      vision: {
        titulo: "Vision",
        cuerpo:
          "To offer a high-quality service from the manufacture to the marketing of our products, adapting ourselves to the needs of our customers through our broad portfolio of brands and products.",
      },
    },
    historia: {
      titulo: "The History of Fiesta",
      boton: "Our<br>History",
      slide1: {
        titulo: "Our origins",
        cuerpo:
          "We were founded in the 1940s in the heart of Puerto Rico by Mr Mayoral, who became interested in the sugar cane crops from day one and started extracting it to create Fiesta’s first sweet.",
        mayoral: "MR MAYORAL",
      },
      slide2: {
        titulo: "A very sweet factory",
        cuerpo:
          "We established our first factory in Venezuela before reaching the city in 1965 that has seen us grow: Alcalá de Henares, in Madrid, where we continue to manufacture the best Fiesta confectionery and sweets.",
        boton: "Discover<br>our journey!",
      },
      slide3: {
        titulo: "Sweets with a heart",
        cuerpo:
          "In the 1960s, we popularised the consumption of flat sweets with a stick and we named it PIRULETA thanks to a play on words with ‘pirulí’ in Spanish (lollipop in English), a typical Cuban sweet, and ‘paleta’ in Spanish (lolly in English), as these sweets used to be called at that time.",
        cuerporae:
          "Years later, the lollipop changed from being round to heart-shaped. This was even added to the Real Academia de la Lengua Española (RAE) [Royal Academy of Spanish Language] and it became a universal symbol.",
        boton: "Read the RAE entry",
        piruli: "Pirulí + paleta",
      },
      slide4: {
        titulosecreto: "Do you want to learn about our best kept secret?",
        descubrir: "Discover",
        sentimos: "Sorry!",
        sentimoscuerpo:
          "Did you really think we were going to tell you about it?",
        sentimosclaim: "¡We’ll never tell!",
        chiclecaramelo: "Bubble gum in a sweet?",
        chiclecuerpo:
          "The launch of the sweet filled with KOJAK bubble gum on a stick, inspired by a popular series at that time, caused a stir in Spain in the 70s.",
        chiclecuerpo2:
          "We were the first to add bubble gum inside a sweet thanks to an innovative process that is still one of the company’s best kept secrets. Until we went out on the TV!",
        tv: [
          "TRAIN ADVENTURE,",
          "Tell me the secret of the extraordinary flavour of Kojak or you’ll be crushed by a train at 4pm,",
          "It tastes wonderful!",
          "And the ones that have bubble gum inside",
          "BOOM!",
          "Kojak, the best from Fiesta. A secret that’s just between me and you",
          "And don’t tell the baddy.",
          "CLIFF ADVENTURE,",
          "Tell me the secret of the extraordinary flavour of Kojak or you’ll die falling off a cliff,",
          "It tastes wonderful!",
          "And the ones that have bubble gum inside",
          "BOOM!",
          "Kojak, the best from Fiesta. A secret that’s just between me and you",
          "And don’t tell the baddy.",
        ],
      },
      slide5: {
        titulo: "The most playful and fun",
        cuerpo:
          "In the mid-80s, the fantastic idea occurred to us of putting sour powder and a sweet lollipop in the shape of Fresquito’s finger in the same packet. Fresquito was the iconic little boy who brought kids and adults together during their sweet moments.",
      },
      slide6: {
        tituloinvasion: "The rise of the gums",
        cuerpoinvasion:
          "The imagination and creativity of our team turned their hand to the creation of delicious gum sweets in the shape of fruits, animals and famous characters in animated cartoons of that era.",
      },
      slide7: {
        titulo: "Sweet Innovation",
        cuerpo:
          "Once more, we were pioneers in the category, with the installation of new liquorice lines, creating a wide range of jelly sweets, using the highest quality, state-of-the-art technology until our brands such as Maromas and Megatorcidas became global best-sellers.",
        cuerpo2: "We’ve now been all over the world with our liquorice!",
      },
      slide8: {
        titulo: "Setting records!",
        cuerpo:
          "We were entered into the Guinness Book of World Records with the highest concentration of people sucking on lollipops. Almost 13,000 people enjoyed our KOJAK lollipop at the same time on 7 September 2008 in Valladolid, Spain.",
        cuerpo2: "This record was easy!",
      },
      slide9: {
        titulo: "Say it with lollipops",
        cuerpo:
          "Becoming fifty years old is a big claim, but when we’re talking about FIESTA lollipops it doesn’t seem so strange. These delicious heart-shaped lollipops have been shared at so many birthdays, kids parties and special events for adults and kids alike that all that remains is for us to wish a Happy Birthday and long live Fiesta!",
        felizcumple: " <strong>Happy</strong> birthday",
      },
      irhome: "Go to<br>Home",
    },
    faqs: {
      titulo: "Frequently asked questions",
      introbanner: "Fiesta Find the answer you need",
      categorias: {
        "0": "About Fiesta",
        "1": "Products",
        "2": "Contact Fiesta",
        "3": "Buy Fiesta",
      },
    },
    formulario: {
      Name: "Name",
      nombre_apellidos: "Full name",
      apellidos: "Last name(s)",
      primerapellido: "First surname",
      segundoapellidos: "Second surname",
      email: "Email",
      medio: "Means of communication",
      mensaje: "Message",
      telefono: "Telephone",
      poblacion: "Community",
      fechanacimiento: "Date of birth",
      he_leido: "I have read and accept the",
      y_acepto: "privacy policy",
      de_fiesta: "by FIESTA",
      comunicaciones:
        "I want to receive marketing communications to be able to continue hearing about FIESTA!",
      cp: "Postcode",
      lote: "Batch number",
      direccion: "Collection/delivery address",
      finalizar: "Complete your registration",
      hombre: "Male",
      mujer: "Female",
      motivo: "Reason",
      enviado: "Sent",
      ticket: "Attached purchase receipt",
      participar: "Participate",
      nombre: "Name",
      departamentos: {
        "": "Departament",
        Fábrica: "Factory",
        Almacén: "Warehouse",
        Administración: "Board",
        "Recursos Humanos": "Human Resources",
        Comercial: "Commercial",
        Marketing: "Marketing",
      },
      departamentoscontacto: {
        "": "Select department",
        "0": "Information",
        "1": "Quality/Complaints",
        "2": "Job",
        "3": "Commercial",
        "4": "Marketing",
      },
      motivos: {
        "nueva apertura": "New opening",
        información: "Information",
        reclamación: "Claim",
      },
      zonas: {
        "": "Area",
        norte: "North",
        sur: "South",
      },
      motivoscontacto: {
        "": "Select Reason",
        Incidencia: "Incident",
        Información: "Information",
        Reclamación: "Claim",
        Sugerencias: "Suggestions",
      },
      fotoproducto: "Product photo",
    },
    politica: {
      titulo: "Privacy policy",
    },
    cookies: {
      titulo: "Cookies policy",
    },
    aviso_legal: {
      titulo: "Legal Notice",
    },
    mapa_web: {
      titulo: "Site map",
      sobrefiesta: "About Fiesta",
      lomastop: "The coolest",
      contacta: "Contact Us",
    },
    canal_informante: {
      titulo: "Informant Channel",
    },
    years: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    distribuidores_list: [
      {
        Nombre: "Andrés Almeida García",
        Correo: "aalmeida@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735045",
        provincias: ["asturias", "cantabria", "navarra", "vizcaya"],
      },
      {
        Nombre: "Aurelio Castro Cobos",
        Correo: "acastroc@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "679306438",
        provincias: ["badajoz", "caceres", "cordoba", "sevilla"],
      },
      {
        Nombre: "Fernando Aspiazu Zarandona",
        Correo: "faspiazu@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735046",
        provincias: ["guipuzcoa", "vizcaya"],
      },
      {
        Nombre: "Fernando Suarez García",
        Correo: "fsuarezg@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "657598864",
        provincias: ["ceuta", "melilla", "cadiz", "malaga", "sevilla"],
      },
      {
        Nombre: "Francisco Javier Martínez Touriño",
        Correo: "fmartinezt@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "656778265",
        provincias: ["la-coruna", "lugo", "orense", "pontevedra"],
      },
      {
        Nombre: "Guillermo Vea-Murguia Merck",
        Correo: "gveamurguia@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "665292482",
        provincias: [
          "huesca",
          "la-rioja",
          "navarra",
          "teruel",
          "barcelona",
          "girona",
        ],
      },
      {
        Nombre: "Iñaki Urrosolo muñoz",
        Correo: "iurrosolo@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735052",
        provincias: [],
      },
      {
        Nombre: "Israel Castaño Hidalgo",
        Correo: "icastano@fiesta.es",
        dpto: "Ventas Exportacion",
        movil: "649896414",
        provincias: [],
      },
      {
        Nombre: "José Luis Carralero Martín-Albó",
        Correo: "jcarralero@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735028",
        provincias: ["madrid", "toledo"],
      },
      {
        Nombre: "José Rey Antúnez",
        Correo: "jrey@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735063",
        provincias: ["barcelona", "girona", "lerida", "tarragona"],
      },
      {
        Nombre: "Luis Fernando Cuadrado",
        Correo: "lcuadrado@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "665292481",
        provincias: [],
      },
      {
        Nombre: "Marcos Díaz Servera",
        Correo: "mdiazs@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735061",
        provincias: ["mallorca", "ibiza", "menorca"],
      },
      {
        Nombre: "Miguel A. del Álamo Carbonero",
        Correo: "madelalamo@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735037",
        provincias: [
          "burgos",
          "leon",
          "palencia",
          "salamanca",
          "soria",
          "valladolid",
          "zamora",
        ],
      },
      {
        Nombre: "Néstor Blázquez Muñoz",
        Correo: "nblazquezm@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "657599001",
        provincias: ["huelva", "sevilla"],
      },
      {
        Nombre: "Nicolás Delgado Otero",
        Correo: "ndelgado@colombina.com",
        dpto: "Ventas Exportacion",
        movil: "605839094",
        provincias: [],
      },
      {
        Nombre: "Pedro José Díaz Hornos",
        Correo: "phornos@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735029",
        provincias: ["albacete", "cuenca", "guadalajara", "madrid  ", "toledo"],
      },
      {
        Nombre: "Roberto Carlos Guerra Ortiz",
        Correo: "rguerra@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735035",
        provincias: ["gran-canaria", "tenerife"],
      },
      {
        Nombre: "Salvador Enrique García López",
        Correo: "segarcia@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735043",
        provincias: ["alicante", "almeria", "castellon", "murcia", "valencia"],
      },
      {
        Nombre: "Sergio Alcántara Castro",
        Correo: "salcantara@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "678735058",
        provincias: ["almeria", "granada", "jaen"],
      },
      {
        Nombre: "Victor Lendínez Andrés",
        Correo: "vlendinez@fiesta.es",
        dpto: "Ventas Nacional",
        movil: "696498168",
        provincias: ["madrid", "segovia", "toledo"],
      },
    ],
    provincias: {
      alava: "Álava",
      albacete: "Albacete",
      alicante: "Alicante",
      almeria: "Almería",
      asturias: "Asturias",
      avila: "Ávila",
      badajoz: "Badajoz",
      barcelona: "Barcelona",
      burgos: "Burgos",
      caceres: "Cáceres",
      cadiz: "Cádiz",
      cantabria: "Cantabria",
      castellon: "Castellón",
      "ciudad-real": "Ciudad Real",
      cordoba: "Córdoba",
      "la-coruna": "La Coruña",
      cuenca: "Cuenca",
      girona: "Girona",
      granada: "Granada",
      guadalajara: "Guadalajara",
      guipuzcoa: "Guipúzcoa",
      huelva: "Huelva",
      huesca: "Huesca",
      "Islas Baleares": "Islas Baleares",
      mallorca: "Mallorca",
      ibiza: "Ibiza",
      menorca: "Menorca",
      jaen: "Jaén",
      leon: "León",
      lerida: "Lérida",
      lugo: "Lugo",
      madrid: "Madrid",
      malaga: "Málaga",
      murcia: "Murcia",
      navarra: "Navarra",
      orense: "Orense",
      palencia: "Palencia",
      "gran-canaria": "Las Palmas de Gran Canaria",
      pontevedra: "Pontevedra",
      "la-rioja": "La Rioja",
      salamanca: "Salamanca",
      segovia: "Segovia",
      sevilla: "Sevilla",
      soria: "Soria",
      tarragona: "Tarragona",
      tenerife: "Santa Cruz de Tenerife",
      teruel: "Teruel",
      toledo: "Toledo",
      valencia: "Valencia",
      valladolid: "Valladolid",
      vizcaya: "Vizcaya",
      zamora: "Zamora",
      zaragoza: "Zaragoza",
    },
    errors: {
      "2": {
        titulo: "We're sorry",
        cuerpo: "Missing required data",
      },
      "3": {
        titulo: "We're sorry",
        cuerpo: "This pin code has already been used",
      },
      "4": {
        titulo: "We're sorry",
        cuerpo:
          "This pin code is not valid or does not belong to this promotion",
      },
      "6": {
        titulo: "We're sorry",
        cuerpo: "The promo has ended",
      },
      "7": {
        titulo: "We're sorry",
        cuerpo: "You have reached the entry limit for today",
      },
      "5": {
        titulo: "We're sorry",
        cuerpo: "Not valid user",
      },
      "8": {
        titulo: "We're sorry",
        cuerpo: "Enter and share again tomorrow to win an extra go!",
      },
      ok: {
        titulo: "Congratulations!",
        cuerpo: "You now have an extra entry",
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/translations/index.js